
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 0h16v5H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(0 8.907)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"fill":"#000","d":"M15.925.237A.5.5 0 0015.5 0h-4.333a.5.5 0 00-.5.5c0 .827-.673 1.5-1.5 1.5H.5a.497.497 0 00-.44.264.498.498 0 00.024.513l1.333 2c.093.14.249.223.416.223H13.5c.19 0 .363-.107.447-.277l2-4a.498.498 0 00-.022-.486","mask":"url(#b)"}})]),_c('path',{attrs:{"fill":"#000","d":"M14.667 6.407c0-.274-.227-.5-.5-.5-.274 0-.5.226-.5.5V8.24h1V6.407zm-10 2.666a.5.5 0 01-1 0V7.407a.5.5 0 011 0v1.666zM3 9.073a.5.5 0 01-1 0V7.407a.5.5 0 011 0v1.666zM.667 10.24H6v-4H.667v4zM9 9.073c0 .274-.227.5-.5.5s-.5-.226-.5-.5V7.407c0-.274.227-.5.5-.5s.5.226.5.5v1.666zm.987.46a.491.491 0 01-.32-.46V7.407c0-.274.226-.5.5-.5.273 0 .5.226.5.5v.953c.153-.08.32-.12.5-.12H12v-2H6.667v4h2.5c.413 0 .76-.307.82-.707zm-5.32-5.126a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zM3 4.407a.5.5 0 01-1 0v-1a.5.5 0 011 0v1zM6 2.74a.5.5 0 00-.5-.5H.667v3.333H6V2.74z"}})])])
          )
        }
      }
    